import useWorldStore from '../store/worldStore';
import AgentMesh from './AgentMesh';
import useZoneBehavior from '../simulation/useZoneBehavior';
import useDragAgent from '../interaction/useDragAgent';

export default function AgentLayer() {
  useZoneBehavior();

  const agents = useWorldStore((s) => s.agents);
  const draggedAgentId = useWorldStore((s) => s.draggedAgentId);
  const dragHandlers = useDragAgent();

  return (
    <group>
      {/* Invisible floor plane for drag tracking */}
      <mesh
        rotation-x={-Math.PI / 2}
        position-y={0}
        onPointerMove={dragHandlers.onPointerMoveR3F}
        onPointerUp={dragHandlers.onPointerUpR3F}
      >
        <planeGeometry args={[100, 100]} />
        <meshBasicMaterial transparent opacity={0} />
      </mesh>

      {agents.map((agent) => (
        <AgentMesh
          key={agent.id}
          agent={agent}
          isDragged={draggedAgentId === agent.id}

          dragHandlers={dragHandlers}
        />
      ))}
    </group>
  );
}
